import { Box, styled } from '@mui/material';
import color from 'src/theme/color';

export const Container = styled(Box)`
    background-color: ${color.blackRock};
    margin-top: 30px;
    border-radius: 4px;
`;

export const DescriptionText = styled('div')`
    color: ${color.white};
`;

export const MarkdownContainer = styled(Box)`
    padding: 10px;
    .wmde-markdown {
        background-color: transparent;
        font-size: 14px;
        color: ${color.white};

        a {
            text-decoration: underline;

            &:hover {
                text-decoration: none;
            }
        }

        pre {
            padding: 1em;
            border-radius: 4px;
            overflow-x: auto;
            color: ${color.black};
        }
    }
`;

export const Timestamp = styled('div')`
    font-size: 10px;
    color: #888;
    margin-top: 4px;
    display: flex;
    justify-content: flex-end;
`;
